import {
  Bell,
  FileClock,
  FileText,
  Package,
  Receipt,
  RotateCcw,
  ShieldAlert,
  Wallet,
} from "lucide-react";
import { cn } from "@/components/ui/utils";
import type { NotificationCategory } from "@/features/notifications/types";

interface CategoryStyle {
  className: string;
  Icon: typeof Bell;
}

const styles: Record<NotificationCategory, CategoryStyle> = {
  invoice: {
    Icon: FileText,
    className: "bg-info-subtle text-info-on-subtle",
  },
  estimate: {
    Icon: FileClock,
    className: "bg-primary/10 text-primary",
  },
  payment: {
    Icon: Wallet,
    className: "bg-success-subtle text-success-on-subtle",
  },
  credit: {
    Icon: RotateCcw,
    className: "bg-success-subtle text-success-on-subtle",
  },
  expense: {
    Icon: Receipt,
    className: "bg-destructive-subtle text-destructive-on-subtle",
  },
  purchase_order: {
    Icon: Package,
    className: "bg-info-subtle text-info-on-subtle",
  },
  security: {
    Icon: ShieldAlert,
    className: "bg-warning-subtle text-warning-text",
  },
  system: {
    Icon: Bell,
    className: "bg-muted text-muted-foreground",
  },
};

interface NotificationIconProps {
  category: NotificationCategory;
  className?: string;
}

/** Category glyph for a notification, derived from its ERP entity type. */
export function NotificationIcon({ category, className }: NotificationIconProps) {
  const { Icon, className: tone } = styles[category];

  return (
    <span
      className={cn(
        "flex size-10 shrink-0 items-center justify-center rounded-xl ring-1 ring-border/60",
        tone,
        className,
      )}
    >
      <Icon aria-hidden="true" className="size-5" />
    </span>
  );
}
